export default "__VITE_ASSET__D5iYlmbM__"